import { useMutation } from '@tanstack/react-query'
import { aiProxyBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface OcrDocumentTextResponse {
  text: string
  truncated: boolean
  originalLength: number
}

export function useOcrDocumentText() {
  const fetchRequest = useFetch<OcrDocumentTextResponse>()

  return useMutation<OcrDocumentTextResponse, Error, File>({
    mutationFn: (file: File) => {
      const formData = new FormData()
      formData.append('file', file)

      return fetchRequest(
        `${aiProxyBase()}/documents/ocr-text`,
        undefined,
        undefined,
        'POST',
        formData,
      )
    },
  })
}
